'use strict';

import config from './const'

(function () {

  $(window).on('load resize', function() {
    if (window.matchMedia('(max-width:960px)').matches) {
      mobile_gnav();
    }
  });

  pageTopLoading();
  startPlanime();
  gallery_txt();
  page_current_check();
  // company_cat_check();
  hb_num_check();
  top_header_bg();
  submit_check();
  sticky_fill();
  tap_like_icon();

  // ローカル用
  mobile_search_slidemenu();

  /* =====================================
    スクロールトップ
  ===================================== */
  $('a[href^="#"]').on('click tap', function () {
    const speed = 500,
      href = $(this).attr("href"),
      target = $(href == "#" || href == "" ? 'html' : href),
      cp_sticky_nav = $('.company-sticky-header').outerHeight() * 1.5, //カンパニーページスティッキーナビの高さ
      position = target.offset().top,
      cp_position = target.offset().top - cp_sticky_nav;

    if ($('.company-sticky-header').length) {
      $("html, body").animate({ scrollTop: cp_position }, speed, "swing");
    } else {
      $("html, body").animate({ scrollTop: position }, speed, "swing");
    }

    return false;
  });

  $('.sm-btn-search').on('click tap', function () {
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });

  /* =====================================
    スクロール量が画面の高さを超えた時 背景にぼかしをかける
  ===================================== */
  // var windowHeight = $(window).height(),
  if (window.matchMedia('(max-width:960px)').matches) {
    var windowHeight = $(window).height() * 0.3;
  } else {
    var windowHeight = $(window).height() * 0.5;
  }
  var elm = $('.company-bg__main');

  $(window).scroll(function (){
    var position = $(window).scrollTop();
    if (position > windowHeight) {
      elm.addClass('blur');
    } else {
      elm.removeClass('blur');
    }
  });



  // /* =====================================
  // 	サイドバー検索メニュー使用時の横幅可変を防ぐ
  // ===================================== */
  // var sidecntWidth = $('.side-select').width();
  // $('.search-box').css('width',sidecntWidth);

}());


var connecting = false;
$(function(){

  /*=======================================
  modal フォロー
  =========================================*/
  // https://qiita.com/MikaShirahama/items/cfe8538be59101c514f3
  $('.js-modal-follow').on('click', function(){
    $('.follow-err').text('');
    $(this).blur(); //ボタンからフォーカスをはずす
    $('body').addClass('body-noscroll');
    $('.modal-follow .wrap').hide();
    if($('.overlay')[0]){ // すでにオーバーレイが存在していたら何もしない
      return false;
    }
    $('body').append('<div class="overlay"></div>'); // オーバーレイをセット
    $('.overlay').hide().fadeIn(300);
    $('.modal-follow').fadeIn(400);
    $('.modal-follow .follow1').show().addClass('open');
    // localstorageにアドレスがある場合はセット
    var user_email = localStorage.getItem(config.localStorageEmailLabel);
    if( user_email != null ) {
      $('#follow-email').val(user_email);
    }
    // submitをトリガーにfollow用のapiを叩く
    $('.modal-follow .submit button').on('click' , function(e) {
      if(connecting) return false; //ajax通信中の場合return
      e.preventDefault();
      submitFollow();
    });
    $('.follow-form').on('submit', function(e) {
      if(connecting) return false;
      e.preventDefault(); //submitキャンセル
      submitFollow();
    });

    // オーバーレイとモーダルをaddでまとめてフェードアウト後モーダル自身を削除
    $('.overlay').add($('.close')).on('click', function(){
      $('.modal-follow .wrap').removeClass('open');
      $('body').removeClass('body-noscroll');
      $('.modal-follow').add($('.overlay')).fadeOut(300, function(){
        $('.overlay').remove();
      });
    });
  });

  function submitFollow() {
    var id = $('#hidden_id').val();
    var email = $('#follow-email').val();
    if( !validateEmail(email) ) {
      $('.follow-err').text('メールアドレス形式で入力してください。');
      return;
    }else {
      $('.follow-err').text('');
    }
    // ボタン連打を抑止
    connecting = true;
    $('.modal-follow .loading').show();
    $('.modal-follow .submit button').prop("disabled", true);
    // follow用apiにPOST
    $.ajax({
      url:'/wp-json/follow/v0/follow',
      type:'POST',
      data:{
        'id': id,
        'email': email
      }
    })
      .done( function(response) {
        // localstrageに保存
        if( localStorage.getItem(config.localStorageEmailLabel) === null ) {
          localStorage.setItem(config.localStorageEmailLabel, email);
        }
        // フォロー完了画面表示
        $('.modal-follow .follow1').removeClass('open').hide();
        $('.modal-follow .follow2').show();
        $('.modal-follow .follow2').addClass('open');
      })
      .fail( function(response) {
        // エラー
        // console.log(response);
        $('.follow-err').text(response.responseJSON.msg);
      })
      .always( function(response) {
        connecting = false;
        $('.modal-follow .loading').hide();
        $('.modal-follow .submit button').prop("disabled", false);
      })

  };

  // email validation
  function validateEmail (email) {
    if( email.match(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i) ) {
      return true;
    }else {
      return false;
    }
  };

  /*=======================================
  modal この企業と話したい
  =========================================*/
  // https://qiita.com/MikaShirahama/items/cfe8538be59101c514f3
  $('.js-modal-talk').on('click', function(){
    $(this).blur(); //ボタンからフォーカスをはずす
    $('.modal-talk .wrap').hide(); // モーダルコンテンツを消す
    $('body').addClass('body-noscroll');
    if($('.overlay')[0]){ // すでにオーバーレイが存在していたら何もしない
      return false;
    }
    $('body').append('<div class="overlay"></div>'); // オーバーレイをセット
    $('.overlay').hide().fadeIn(300);
    $('.modal-talk').fadeIn(400);
    $('.modal-talk .step1').show().addClass('open');
    $('.modal-talk .add-modal').show().addClass('open');
    var post_data = {};
    $('.modal-talk .step1 .submit').on('click' , function() {
      // 値取得
      post_data.hope = $('[name=hope]:checked').val();
      post_data.hope_other = $('#hope-other').val();
      post_data.hopecontact = $('[name=hopecontact]:checked').val();

      // step2へ
      $('.modal-talk .step1').removeClass('open');
      $('.modal-talk .step1').hide();
      $('.modal-talk .step2').show();
      $('.modal-talk .step2').addClass('open');
    });
    $('.modal-talk .step2 .submit').on('click' , function() {
      var err_flg = false;
      // 値取得、バリデーション
      var name_last = $('input[name=name_last]').val();
      var name_first = $('input[name=name_first]').val();
      var name_last_kana = $('input[name=name_last_kana]').val();
      var name_first_kana = $('input[name=name_first_kana]').val();
      var tel1 = $('input[name=tel1]').val();
      var tel2 = $('input[name=tel2]').val();
      var tel3 = $('input[name=tel3]').val();
      var email1 = $('input[name=email1]').val();
      var recruit_title = $('input[name=recruit_title]').val();

      if( !name_last ) {
        $('.step2 .error-box').addClass('show');
        $('input[name=name_last]').addClass('error');
        $('input[name=name_last]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=name_last]').removeClass('error');
      }
      if( !name_first ) {
        $('.step2 .error-box').addClass('show');
        $('input[name=name_first]').addClass('error');
        $('input[name=name_first]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=name_first]').removeClass('error');
      }
      if( !name_last_kana ) {
        $('.step2 .error-box').addClass('show');
        $('input[name=name_last_kana]').addClass('error');
        $('input[name=name_last_kana]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=name_last_kana]').removeClass('error');
      }
      if( !name_first_kana ) {
        $('.step2 .error-box').addClass('show');
        $('input[name=name_first_kana]').addClass('error');
        $('input[name=name_first_kana]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=name_first_kana]').removeClass('error');
      }
      // var tel1_rep = tel1.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,'');
      // if( !tel1 || !tel1_rep.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/) ) {
      // 	$('.step2 .error-box').addClass('show');
      // 	$('input[name=tel1]').addClass('error');
      // 	$('input[name=tel1]').parents('.contact').prev('.error-message').addClass('show');
      // 	err_flg = true;
      // }else {
      // 	$('input[name=tel1]').removeClass('error');
      // }
      if( !tel1 || !tel1.match(/^([+-])?([0-9]+)(\.)?([0-9]+)?$/)) {
        $('.step2 .error-box').addClass('show');
        $('input[name=tel1]').addClass('error');
        $('input[name=tel1]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=tel1]').removeClass('error');
      }
      if( !tel2 || !tel2.match(/^([+-])?([0-9]+)(\.)?([0-9]+)?$/)) {
        $('.step2 .error-box').addClass('show');
        $('input[name=tel2]').addClass('error');
        $('input[name=tel2]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=tel2]').removeClass('error');
      }
      if( !tel3 || !tel3.match(/^([+-])?([0-9]+)(\.)?([0-9]+)?$/)) {
        $('.step2 .error-box').addClass('show');
        $('input[name=tel3]').addClass('error');
        $('input[name=tel3]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=tel3]').removeClass('error');
      }

      if( !email1 || !validateEmail(email1) ) {
        $('.step2 .error-box').addClass('show');
        $('input[name=email1]').addClass('error');
        $('input[name=email1]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=email1]').removeClass('error');
      }
      if( err_flg ) return false;

      post_data.name_last = name_last;
      post_data.name_first = name_first;
      post_data.name_last_kana = name_last_kana;
      post_data.name_first_kana = name_first_kana;
      post_data.tel = tel1 + '-' + tel2 + '-' + tel3;
      post_data.email = email1;
      post_data.recruit_title = recruit_title;

      // step3へ
      $('.modal-talk .step2').removeClass('open');
      $('.modal-talk .step2').hide();
      $('.modal-talk .step3').show();
      $('.modal-talk .step3').addClass('open');
    });
    $('.modal-talk .step3 .submit').on('click' , function() {
      // ボタン連打を抑止
      if( connecting ) return false;

      var err_flg = false;
      var $contact_age = $('#contact-age .selectric-items li.selected');
      var $contact_job = $('#contact-job .selectric-items li.selected');
      var $postal_code = $('input[name=postal_code_1]');
      var $prefectures = $('#contact-prefectures .selectric-items li.selected');
      var $address = $('input[name=address]');
      var $startjobs = $('input[name=startjobs]');
      var $hopejobs = $('input[name=hopejobs]');
      var $hopeworklocation = $('input[name=hopeworklocation]');
      var $hopecontact2 = $('input[name=hopecontact2]');
      var $member = $('input[name=member]');
      var $points = $('input[name=points]');
      var $reason = $('#contact-reason');


      // 要素が存在し、かつ値が空の場合はエラー
      if( $contact_age.length && ($contact_age.text() == '選択してください') ) {
        $('.step3 .error-box').addClass('show');
        $('#contact-age .selectric').addClass('error');
        $('#contact-age').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('#contact-age .selectric').removeClass('error');
        $('#contact-age').parents('.contact').prev('.error-message').removeClass('show');
      }
      if( $contact_job.length && ($contact_job.text() == '選択してください') ) {
        $('.step3 .error-box').addClass('show');
        $('#contact-job .selectric').addClass('error');
        $('#contact-jog').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('#contact-job .selectric').removeClass('error');
        $('#contact-jog').parents('.contact').prev('.error-message').removeClass('show');
      }
      if( $prefectures.length && ($prefectures.text() == '選択してください') ) {
        $('.step3 .error-box').addClass('show');
        $('#contact-prefectures .selectric').addClass('error');
        $('#contact-prefectures').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('#contact-prefectures .selectric').removeClass('error');
        $('#contact-prefectures').parents('.contact').prev('.error-message').removeClass('show');
      }
      if( $postal_code.length && !$postal_code.val() ) {
        $('.step3 .error-box').addClass('show');
        $('input[name=postal_code_1]').addClass('error');
        $('input[name=postal_code_1]').parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $('input[name=postal_code_1]').removeClass('error');
        $('input[name=postal_code_1]').parents('.contact').prev('.error-message').removeClass('show');
      }
      if( $address.length && !$address.val() ) {
        $('.step3 .error-box').addClass('show');
        $address.addClass('error');
        $address.parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $address.removeClass('error');
        $address.parents('.contact').prev('.error-message').removeClass('show');
      }
      if( $member.length && !$member.val() ) {
        $('.step3 .error-box').addClass('show');
        $member.addClass('error');
        $member.parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $member.removeClass('error');
      }
      if( $points.length && !$points.val() ) {
        $('.step3 .error-box').addClass('show');
        $points.addClass('error');
        $points.parents('.contact').prev('.error-message').addClass('show');
        err_flg = true;
      }else {
        $points.removeClass('error');
      }
      // if( $reason.length && !$reason.val() ) {
      // 	$('.step3 .error-box').addClass('show');
      // 	$reason.addClass('error');
      // 	$reason.parents('.contact').prev('.error-message').addClass('show');
      // 	err_flg = true;
      // }else {
      // 	$reason.removeClass('error');
      // 	$reason.parents('.contact').prev('.error-message').removeClass('show');
      // }
      if( err_flg ) return;

      post_data.age = $contact_age.text();
      post_data.job = $contact_job.text();
      post_data.postal_code = $postal_code.val();
      post_data.address = $address.val();
      post_data.startjobs = $startjobs.val();
      post_data.hopejobs = $hopejobs.val();
      post_data.hopeworklocation = $hopeworklocation.val();
      post_data.hopecontact2 = $hopecontact2.val();
      post_data.member = $('input[name=member]:checked').val();
      post_data.reason = $reason.val();
      var points = [];
      $('input[name=points]:checked').map(function() {
        points.push($(this).val());
      });
      post_data.points = points;
      post_data.prefectures = $prefectures.text();

      // submit
      submitEntry(post_data);

    });
    // オーバーレイとモーダルをaddでまとめてフェードアウト後モーダル自身を削除
    $('.overlay').add($('.close')).on('click', function(){
      $('.modal-talk .wrap').removeClass('open');
      $('body').removeClass('body-noscroll');
      $('.modal-talk').add($('.overlay')).fadeOut(300, function(){
        $('.overlay').remove();
      });
    });

    function submitEntry( data ) {
      connecting = true;
      var id = $('#hidden_id').val();
      jQuery(function($) {
        $.ajax({
          url:'/wp-json/entry/v0/add',
          type:'POST',
          data:{
            'id': id,
            'data': data
          }
        })
          .done( function(response) {
            // 完了画面表示
            /*$('.modal-talk .step3').removeClass('open');
            $('.modal-talk .step3').hide();
            $('.modal-talk .step4').show();
            $('.modal-talk .step4').addClass('open');
            */

            // TODO: トラッキング対応時解放
            set_company_contact_thanks_tracking();

            location.href = '/thanks-rec/';

          })
          .fail( function(response) {
            // エラー
            $('.entry-err').text(JSON.stringify(response));
            //$('.entry-err').text(response.responseJSON.msg);
          })
          .always( function(response) {
            connecting = false;
          })
      });
    };

    /**
     * GTAGトラッキング（この企業と話したいの完了）
     */
    function set_company_contact_thanks_tracking() {
      if (typeof gtag === 'function') {
        gtag('event', 'view', {
          'event_category': 'この企業と話したい',
          'event_label': '完了'
        });
      }
    }

  });

  /*=======================================
  modal 埼玉の会社とは チュートリアル
  =========================================*/
  // https://qiita.com/MikaShirahama/items/cfe8538be59101c514f3
  $('.top-about').on('click', function(){
    $(this).blur(); //ボタンからフォーカスをはずす
    if($('.overlay')[0]){ // すでにオーバーレイが存在していたら何もしない
      return false;
    }
    $('body').append('<div class="overlay"></div>'); // オーバーレイをセット
    $('.overlay').hide().fadeIn(300);
    $('.modal-about').fadeIn(400);
    $('.modal-about .wrap , .body-wrap').addClass('open');
    // オーバーレイとモーダルをaddでまとめてフェードアウト後モーダル自身を削除
    $('.overlay').add($('.close')).on('click', function(){
      $('.modal-about .wrap , .body-wrap').removeClass('open');
      $('.modal-about').add($('.overlay')).fadeOut(300, function(){
        $('.overlay').remove();
      });
    });
  });

  /*=======================================
  modal メディアの方へ
  =========================================*/
  // https://qiita.com/MikaShirahama/items/cfe8538be59101c514f3
  $('.f-media').on('click', function () {
    $(this).blur(); //ボタンからフォーカスをはずす
    $('body').addClass('body-noscroll');
    if ($('.overlay')[0]) { // すでにオーバーレイが存在していたら何もしない
      return false;
    }
    $('body').append('<div class="overlay"></div>'); // オーバーレイをセット
    $('.overlay').hide().fadeIn(300);
    $('.modal-writer').fadeIn(400);
    $('.modal-writer .wrap, .body-wrap').addClass('open');
    // オーバーレイとモーダルをaddでまとめてフェードアウト後モーダル自身を削除
    $('.overlay').add($('.close')).on('click', function () {
      $('.modal-writer .wrap, .body-wrap').removeClass('open');
      $('body').removeClass('body-noscroll');
      $('.modal-writer').add($('.overlay')).fadeOut(300, function () {
        $('.overlay').remove();
      });
    });
  });

});

// ユーザーエージェント判定
(function(){
  // var getDevice = (function(){
  // 	var ua = navigator.userAgent;
  // 	if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
  // 		return 'sp';
  // 	} else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
  // 		return 'tab';
  // 	} else {
  // 		return 'other';
  // 	}
  // })();
  // if( getDevice === 'sp' ){ //スマホ
  // 	// スマホのタッチの反応をよくするjs
  // 	// fastClick();

  // 	// モバイルメニュー
  // 	$('.mb-menu').on('click' , function() {
  // 		$(this).toggleClass('open');
  // 		$('.header .inner-c').toggleClass('open');
  // 		$('.top-about').click(function() {
  // 			$('.mb-menu').removeClass('open');
  // 			$('.header .inner-c').removeClass('open');
  // 		})
  // 	});

  // 	var $ul = $('.navigation1');
  // 	// console.log($ul.width());
  // 	var $li = $('.navigation1 .item');

  // 	var sum = 0;
  // 	for (var i = 0; i < $li.length; i++) {
  // 		var $liW = $($li.get(i)).outerWidth();
  // 		sum += $liW;
  // 	}
  // 	// console.log(sum);
  // 	$ul.css('width', sum + 1);

  // } else if( getDevice === 'tab' ){ //タブレット
  // } else if( getDevice === 'other' ){ //その他


  // if (window.matchMedia('(max-width:960px)').matches) {
  // 	// モバイルメニュー
  // 	$('.mb-menu').on('click', function () {
  // 		$(this).toggleClass('open');
  // 		$('.header .inner-c').toggleClass('open');
  // 		$('.top-about').click(function () {
  // 			$('.mb-menu').removeClass('open');
  // 			$('.header .inner-c').removeClass('open');
  // 		})
  // 	});
  // }


  /* =====================================
    トップページ インタビューの抜粋文の横の高さ調整
  ===================================== */
  var lineHeight = $('.itv-cnt .txt .excerpt,.cp-interview .excerpt').height();
  $('.itv-cnt .line,.cp-interview .line').css('height', lineHeight);

  /* =====================================
    トップページ 企業記事の高さ調整
  ===================================== */
  // var maxHeight = 0,
  // 	descCnt = $(".desc-height");
  // descCnt.each(function(){
  // 	if ($(this).height() > maxHeight) {
  // 		maxHeight = $(this).height();
  // 	}
  // });
  // $(".desc-height").height(maxHeight);
}());


// $(window).on('load resize', function () {
// 	ttl_height();
// });


// function ttl_height() {
// 	var maxHeight = 0,
// 	descCnt = $(".js-ttl-height");
// 	descCnt.css('height','');
// 	descCnt.each(function () {
// 		if ($(this).height() > maxHeight) {
// 			maxHeight = $(this).height();
// 			console.log(maxHeight);
// 			$(".js-ttl-height").height(maxHeight);
// 		}
// 	});
// }

function mobile_gnav() {

  // let global_py = 0;
  // $('body').attr('data-scroll','0px');
  // $(window).on('scroll', function () {
  // let pointY = $(window).scrollTop();
  // $('body').attr('data-scroll', pointY);
  // });

  // $('.mb-menu').on('click tap', function () {
  // 	let py = $('body').attr('data-scroll');
  // 	$(this).toggleClass('open');

  // 	if ($('.mb-menu').hasClass('open')) {
  // 		$('.header .inner-c').addClass('open');
  // 		$('body').addClass('body-noscroll');
  // 		// $('body').css({ 'position': 'fixed', 'top': -py, 'width': '100%' });
  // 		global_py = py;
  // 	} else {
  // 		$('.mb-menu').removeClass('open');
  // 		$('.header .inner-c').removeClass('open');
  // 		$('body').removeClass('body-noscroll');
  // 		// $('body').css({ 'position': '', 'width': '', 'top': '' });
  // 		$(window).scrollTop(global_py);
  // 	}

  // 	$('.top-about').on('click', function () {
  // 		$('.mb-menu').removeClass('open');
  // 		$('.header .inner-c').removeClass('open');
  // 		$('body').removeClass('body-noscroll');
  // 		// $('body').css({ 'position': '', 'width': '', 'top': '' });
  // 		$(window).scrollTop(global_py);
  // 	});
  // });

  $('.mb-menu').off('click');
  $('.mb-menu').off('tap');
  $('.mb-menu').on('click tap', function () {
    if (!$(this).hasClass('open')) {
      $(this).addClass('open');
      $('.header .inner-c').addClass('open');
    } else {
      $(this).removeClass('open');
      $('.header .inner-c').removeClass('open');
    }
    $('.top-about').on('click', function () {
      $('.mb-menu').removeClass('open');
      $('.header .inner-c').removeClass('open');
    });
  });
}

/*---------------------------------------------------------------------------------
    page loader
---------------------------------------------------------------------------------*/

function pageTopLoading() {
  if ($('.topPage-loading').length) {
    img_load()
      .then(waitTxthide())
      .then(loadComp())
      .then(svgAnime());
  }
}

function img_load() {
  var d = new $.Deferred;
  $(window).on('load', function () {
    $('#img');
  });
  return d.promise();
}

function waitTxthide() {
  var d = new $.Deferred;
  $('.tpl-wait').fadeOut(300);
  return d.promise();
}

function loadComp() {
  var d = new $.Deferred;
  $('#svgWrapper').delay(1000).queue(function () {
    $(this).addClass('comp').dequeue();
  });
  return d.promise();
}

function svgAnime() {
  new Vivus('js-mask', { duration: 15, type: 'scenario', pathTimingFunction: Vivus.EASE_OUT, }, function (obj) {
    $('.topPage-loading').delay(500).fadeOut(800);
  });
}


function pagepLoading() {
  img_load()
    .then(startPlanime());
}

function startPlanime() {
  $('.loader').addClass('pLcomp');
  $('.page-loading').delay(700).fadeOut(1000);
}


/*---------------------------------------------------------------------------------
    slideout menu
---------------------------------------------------------------------------------*/

function mobile_search_slidemenu() {
  let slideoutMenu = $('.slideout-menu'),
    slideoutMenuWidth = $('.slideout-menu').width(),
    menu = $('.slideout-menu'),
    menuBtn = $('.slideout-menu-toggle'),
    menuOpenBtn = $('.slideout-menu-toggle__open'),
    menuCloseBtn = $('.slideout-menu-toggle__close'),
    body = $(document.body);

  // slideoutMenu.css({ 'right': -slideoutMenuWidth });

  // $('.slideout-menu-toggle').on('click tap', function (event) {
  // 	event.preventDefault();
  // 	body.toggleClass('side-open');

  // 	if (body.hasClass('side-open')) {
  // 		menuBtn.addClass('is-clicked');
  // 		menuCloseBtn.addClass('toggle-fix')
  // 		menu.animate({ 'right': 0 }, 200);

  // 	} else {
  // 		menuBtn.removeClass('is-clicked');
  // 		menuCloseBtn.removeClass('toggle-fix')
  // 		menu.animate({ 'right': -menuWidth }, 200);
  // 		$(window).off('.noScroll');
  // 	}
  // });

  $(window).on('scroll', function () {
    let scrollHeight = $(document).height(),
      scrollPosition = $(window).height() + $(window).scrollTop();
    if ((scrollHeight - scrollPosition) / scrollHeight <= 0.06) {
      menuOpenBtn.addClass('smto_stop_fix');
    } else {
      menuOpenBtn.removeClass('smto_stop_fix');
    }
  });
}


/*---------------------------------------------------------------------------------
    ギャラリーページテキスト
---------------------------------------------------------------------------------*/

function gallery_txt () {
  $('.gallery-layout .item').each(function () {
    let fc_height = $('figcaption',this);
    let h = fc_height.outerHeight();
    fc_height.css('bottom', -h);

    $(this).hover(function () {
      fc_height.animate({ bottom: 0 }, 300);
    }, function () {
      fc_height.animate({ bottom: -h }, 300);
    });
  });
}




/*---------------------------------------------------------------------------------

---------------------------------------------------------------------------------*/

function company_cat_check() {
  let tgt = $('.category-box .ac-list .item a');

  tgt.each(function () {
    $(this).on('click', function () {
      $(this).addClass('check');
      var self = $(this);
      $('.category-box .ac-list .item a').not(self).removeClass('check');
    });
  });

  var menuWidth = $('.slideout-menu').outerWidth();
  tgt.on('click tap', function () {
    if (window.matchMedia('(max-width:960px)').matches) {
      setTimeout(function () {
        $('.slideout-menu-toggle').removeClass('is-clicked');
        $('.slideout-menu-toggle__close').removeClass('toggle-fix')
        $('.slideout-menu').animate({ 'right': -menuWidth }, 200);
        $(window).off('.noScroll');
        $(document.body).removeClass('side-open');
      }, 500);
    }
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });
}


/*---------------------------------------------------------------------------------
    インタビュー シングルページ human-boxの制御
---------------------------------------------------------------------------------*/

function hb_num_check() {
  let counter = 0;
  $('.human-item').each(function () {
    counter++;
  });
  if (counter >= 3) {
    $('.interview-mhWrap').addClass('omp3');
  } else {
    $('.interview-mhWrap').addClass('omp2')
  }
}

/*---------------------------------------------------------------------------------
    トップページヘッダー 背景
---------------------------------------------------------------------------------*/

function top_header_bg() {
  let keyh =$(window).height() * 0.6;
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > keyh) {
      $('.top-header').addClass('top-header__bg');
    } else {
      $('.top-header').removeClass("top-header__bg");
    }
  });
}

/*---------------------------------------------------------------------------------
    sticy fill
---------------------------------------------------------------------------------*/
function sticky_fill() {
  const elem1 = $('.sticky');
  Stickyfill.add(elem1);
  const elem2 = $('.sidebar-sticky');
  Stickyfill.add(elem2);
}


/*---------------------------------------------------------------------------------
  submit check
---------------------------------------------------------------------------------*/
function submit_check() {
  const chkAgreement = $('.agreement-btn')
  const submitBtn = $('.submit button')
  if (chkAgreement.length) {
    if (submitBtn.length) {
      submitBtn.prop('disabled', true)
    }
    chkAgreement.on('change', function () {
      if ($(this).is(':checked')) {
        submitBtn.prop('disabled', false)
        submitBtn.removeClass('disabled')
      } else {
        submitBtn.prop('disabled', true)
        submitBtn.addClass('disabled')
      }
    })
  }
}

/*---------------------------------------------------------------------------------
  ページ内 カレントチェック
---------------------------------------------------------------------------------*/

function page_current_check() {
  if ($('#companyAbout').length) {

    let array = [];
    $('section').each(function () {
      if ($(this).attr('id')) {
        array['#' + $(this).attr('id')] = 0;
      }
    });

    // const array = {
    // 	'#companyAbout': 0,
    // 	'#companyArticle': 0,
    // 	'#companyInterview': 0,
    // 	'#companyJob': 0,
    // 	'#companyMember': 0,
    // 	'#companyOverview': 0
    // };

    const cp_sticky_nav = $('.company-sticky-header').outerHeight() * 1.5;

    let $globalNavi = new Array();

    // 各要素のスクロール値を保存
    for (let key in array) {
      if ($(key).offset()) {
        array[key] = $(key).offset().top - cp_sticky_nav; // 数値丁度だとずれるので10px余裕を作る
        $globalNavi[key] = $('.side-navigation li a[href="' + key + '"]');
      }
    }

    // スクロールイベントで判定
    $(window).scroll(function () {
      for (let key in array) {
        if ($(window).scrollTop() > array[key] - cp_sticky_nav) {
          $('.side-navigation li a').each(function () {
            $(this).removeClass('active');
          });
          $globalNavi[key].addClass('active');
        }
      }
    });
  }
}

/*---------------------------------------------------------------------------------
    いいね通知
---------------------------------------------------------------------------------*/

function tap_like_icon() {
  let $tgt = $('.cnt-header--company .ch-thumb .thumb span .icon-wrap');
  let is_clicked = false;

  $tgt.on('click tap', function() {
    // 連打防止
    if( is_clicked ) return false;
    is_clicked = true;

    const id = $('#company').data('author');
    let email = localStorage.getItem(config.localStorageEmailLabel);
    let user_id = localStorage.getItem(config.localStorageIdLabel);
    const base_url = '/wp-json/like/v0/add';

    // localstorageにuser_idがない場合は生成してセット
    if ( user_id  === null ) {
      let cryptoObj = window.crypto || window.msCrypto;
      let array = new Uint32Array(1);
      cryptoObj.getRandomValues(array);
      let d = new Date();
      user_id = d.getMilliseconds() + array[0];
      localStorage.setItem(config.localStorageIdLabel, user_id);
    }

    $.ajax({
      url: base_url,
      type: 'POST',
      data: {
        'id': id,
        'email': email,
        'user_id': user_id
      }
    })
      .done( function(response) {
        $tgt.addClass('active');
        setTimeout(function() {
          is_clicked = false;
        }, 5000);
      })
      .fail( function(response) {
        is_clicked = false;
      })
      .always( function() {
      })
  })
}
